import { render } from "./MyPageDashboard.vue?vue&type=template&id=59e8f607"
import script from "./MyPageDashboard.vue?vue&type=script&lang=js"
export * from "./MyPageDashboard.vue?vue&type=script&lang=js"

import "./MyPageDashboard.vue?vue&type=style&index=0&id=59e8f607&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__